import firebase from 'firebase/app'
import 'firebase/database'
const db = firebase.database()

export default {
  namespaced: true,
  state: {
    author: null
  },
  getters: {
    getAuthorObject (state) {
      return state.author
    }
  },
  mutations: {
    setProjectAuthor (state, author) {
      state.author = author
    }
  },
  actions: {
    async loadProjectAuthor ({ commit }, { authorId }) {
      const userRef = db.ref(`users/${authorId}`)
      const snapshot = await userRef.once('value')
      const author = snapshot.val()
      commit('setProjectAuthor', author)
    }
  }
}
